import DailyEarningGaps from "./DailyEarningGaps"
import MonthlyEarningGaps from "./MonthlyEarningGaps"


const AnomaliesEarnings = () => {
  return (
    <>
    <DailyEarningGaps/>
    <MonthlyEarningGaps/>
    </>
  )
}

export default AnomaliesEarnings